import PropTypes from "prop-types"
import { Component } from "react"

class Embed extends Component {
  static displayName = "Embed"

  shouldComponentUpdate(nextProps) {
    return nextProps.code !== this.props.code
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.code !== this.props.code) {
      this.embed.innerHTML = nextProps.code
    }
  }

  componentDidMount() {
    // using $.append to execute scripts
    this.embed.innerHTML = this.props.code
  }

  render() {
    return (
      <div
        className="Embed"
        ref={(n) => (this.embed = n)}
        style={{ width: "100%" }}
      />
    )
  }
}

Embed.propTypes = {
  code: PropTypes.string.isRequired
}

Embed.defaultProps = {
  code: null
}

export default Embed
